import { orchestrator } from 'satcheljs';
import setAccountPendingTrueTimeUpdateMutator from '../mutators/setAccountPendingTrueTimeUpdateMutator';
import { lazyRemoveMergedViewAvailabilityAccount } from 'owa-truetime';
import { disconnectOWAAccount } from 'owa-accounts-service';
import { startRemovingAccount } from '../actions/internalActions';
import { AccountsEditorState } from '../store/schema/AccountsEditorState';
import setAccountsEditorState from '../mutators/setAccountsEditorState';
import setSelectedAccountProvider from '../mutators/setSelectedAccountProvider';
import { getAccountAddressForMergedView } from 'owa-accounts-utils';
import getAccountsEditorSource from '../selectors/getAccountsEditorSource';

orchestrator(
    startRemovingAccount,
    async ({ account, mergeViewEnabledAccount, isReconnectFlow }) => {
        const accountsEditorSource = getAccountsEditorSource();

        setSelectedAccountProvider(account.accountProviderType);

        let removeMergedViewAvailability = true;

        if (mergeViewEnabledAccount == getAccountAddressForMergedView(account)) {
            // Show the spinner while waiting for a response from the server
            setAccountPendingTrueTimeUpdateMutator(account.userIdentity);
            setAccountsEditorState(AccountsEditorState.Removing);

            let removeMergedView = await lazyRemoveMergedViewAvailabilityAccount.import();
            removeMergedViewAvailability = await removeMergedView(
                account.accountProviderType,
                accountsEditorSource,
                'RemoveAccount' /* SourceTrigger */
            );

            // Hide the spinner now that we have a response from the server
            setAccountPendingTrueTimeUpdateMutator(null);
        }

        if (removeMergedViewAvailability) {
            disconnectOWAAccount(account, accountsEditorSource, isReconnectFlow);
        } else {
            setAccountsEditorState(
                isReconnectFlow
                    ? AccountsEditorState.ReconnectFailed
                    : AccountsEditorState.RemoveFailed
            );
        }
    }
);
